/**
 * Tự phát hiện deploy FE mới (index.html / entry JS đổi hash) và reload ngầm.
 * Chạy production only — tránh loop với dev server / HMR.
 */
const CHECK_INTERVAL_MS = 10 * 60 * 1000;
const RELOAD_GUARD_KEY = "social_version_reload_ts";
const RELOAD_COOLDOWN_MS = 30_000;
const ENTRY_SCRIPT_RE = /(?:index|app)\.[a-z0-9]+\.js/i;
function getLocalEntryScript() {
    for (const el of Array.from(document.querySelectorAll("script[src]"))) {
        const src = el.src;
        if (!src)
            continue;
        const name = src.split("/").pop()?.split("?")[0] || "";
        if (ENTRY_SCRIPT_RE.test(name)) {
            return name.toLowerCase();
        }
    }
    return null;
}
function parseServerSignature(html) {
    const meta = html.match(/<meta\s+name=["']social-build["']\s+content=["']([^"']+)["']/i);
    if (meta?.[1]) {
        return meta[1].trim();
    }
    const index = html.match(/index\.([a-z0-9]+)\.js/i);
    if (index) {
        return `index.${index[1].toLowerCase()}.js`;
    }
    const app = html.match(/app\.([a-z0-9]+)\.js/i);
    if (app) {
        return `app.${app[1].toLowerCase()}.js`;
    }
    return null;
}
function getLocalSignature() {
    const fromEnv = String(process.env.VUE_APP_BUILD_ID || "").trim();
    if (fromEnv) {
        return fromEnv;
    }
    return getLocalEntryScript() || "";
}
async function fetchServerSignature() {
    const url = `/index.html?_=${Date.now()}`;
    const res = await fetch(url, {
        cache: "no-store",
        credentials: "same-origin",
    });
    if (!res.ok) {
        return null;
    }
    const html = await res.text();
    return parseServerSignature(html);
}
function signaturesDiffer(local, server) {
    if (!local || !server) {
        return false;
    }
    if (local === server) {
        return false;
    }
    // Legacy app.* đang chạy, server đã index.* (hoặc ngược lại)
    const localIsApp = local.startsWith("app.");
    const serverIsIndex = server.startsWith("index.");
    if (localIsApp && serverIsIndex) {
        return true;
    }
    return local !== server;
}
async function checkAndReloadIfStale() {
    try {
        const server = await fetchServerSignature();
        const local = getLocalSignature();
        if (!server || !local || !signaturesDiffer(local, server)) {
            return;
        }
        const last = sessionStorage.getItem(RELOAD_GUARD_KEY);
        if (last && Date.now() - Number(last) < RELOAD_COOLDOWN_MS) {
            return;
        }
        sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
        window.location.reload();
    }
    catch {
        /* mạng / offline — bỏ qua */
    }
}
/** Gọi một lần từ main.ts (production). */
export function startAutoVersionReload() {
    if (typeof window === "undefined" || process.env.NODE_ENV !== "production") {
        return;
    }
    void checkAndReloadIfStale();
    window.setInterval(() => {
        void checkAndReloadIfStale();
    }, CHECK_INTERVAL_MS);
    document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") {
            void checkAndReloadIfStale();
        }
    });
    window.addEventListener("pageshow", (ev) => {
        if (ev.persisted) {
            void checkAndReloadIfStale();
        }
    });
}
